import React from "react";
import "./TextChange.css";
const TextChange = () => {
  return (
    <div id="container" className="tagline">
      <div id="flip" className="tagline">
        <div>
          <div className="tagline">{"AI product"}</div>
        </div>
        <div>
          <div className="tagline">{"innovation"}</div>
        </div>
        <div>
          <div className="tagline">{"success!"}</div>
        </div>
      </div>
    </div>
  );
};

export { TextChange };
